// src/services/api.js
import axios from 'axios';

// Use environment variable if available, otherwise use production URL
// For local development, you can set REACT_APP_API_URL=http://localhost:3001
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to add auth token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Public API instance for endpoints that should NEVER include auth headers
const publicApi = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

export { api, publicApi };

// Response interceptor to handle errors
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        // DISABLED: Mock API fallback - using real backend now
        // if (error.config?.url?.includes('/api/documents') &&
        //     (error.response?.status === 404 || error.response?.status === 500)) {
        //     console.log('🔄 Document API failed, using mock instead...');
        //     // ... mock API logic
        // }

        // Only logout on 401 if NOT on the login page and NOT for auth/public endpoints
        // OTP endpoints and verify-phone should not trigger logout as they are login endpoints
        const url = error.config?.url || '';
        const isLoginPage = window.location.pathname === '/login' || window.location.pathname === '/';
        const isResetPasswordPage = window.location.pathname === '/reset-password';
        const isPublicAuthEndpoint = url.includes('send-otp') ||
                                     url.includes('verify-otp') ||
                                     url.includes('verify-phone') ||
                                     url.includes('forgot-password') ||
                                     url.includes('reset-password') ||
                                     url.includes('/api/public/') ||
                                     url.includes('check-email-duplicate') ||
                                     url.includes('check-phone-duplicate') ||
                                     url.includes('send-email-otp') ||
                                     url.includes('verify-email-otp') ||
                                     url.includes('send-phone-otp') ||
                                     url.includes('verify-phone-otp') ||
                                     url.includes('register-organization');

        // Check if using demo/local token (these won't be valid on backend)
        const token = localStorage.getItem('authToken') || '';
        const isDemoToken = token.startsWith('otp-token-') ||
                           token.startsWith('demo-token-') ||
                           token.startsWith('local-token-');

        // Don't redirect if:
        // 1. We're already on login page
        // 2. On reset password page
        // 3. Hitting public auth endpoints
        // 4. Using demo token (backend will reject but that's expected in demo mode)
        if (error.response?.status === 401 && !isLoginPage && !isResetPasswordPage && !isPublicAuthEndpoint && !isDemoToken) {
            localStorage.removeItem('authToken');
            localStorage.removeItem('user');
            localStorage.removeItem('company');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);